import { render, staticRenderFns } from "./investment_type.vue?vue&type=template&id=6b0d7caf&"
import script from "./investment_type.vue?vue&type=script&lang=js&"
export * from "./investment_type.vue?vue&type=script&lang=js&"
import style0 from "./investment_type.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports